import React from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'

const SimpleDeleteModal = ({ isOpen, onClose, text, onConfirm, isLoading }) => (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      <Typography>{text}</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onConfirm}
        color='secondary'
        variant='contained'
        disabled={isLoading}
      >
        {isLoading ? <CircularProgress size={20} /> : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
)

SimpleDeleteModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  text: PropTypes.string,
  onConfirm: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default SimpleDeleteModal
